import React, {useEffect, useState} from 'react';
import {
   View,
   Text,
   StyleSheet,
   TextInput,
   TouchableOpacity,
   Platform,
   Image,
   NativeModules,
} from 'react-native';
import {
   AccountSignIn,
   ACCOUNT_EMAIL,
   ACCOUNT_PASSWORD,
   appBackgroundWhiteBG,
   AUTHDATA,
   base100,
   buttonBorderColor,
   CONTACT_US,
   DoNotHaveAnAccount,
   FORGOT_PASSWORD,
   GET_LOGIN,
   NORCAT_ORG,
   primaryColor400,
   primaryColor500,
   primaryState300,
   primaryState800,
   QrSignIn,
   redirectToBrowser,
   REMEMBER_ACCOUNT,
   SignIn,
   white,
   FONT_FAMILY_SEMI_BOLD,
   FONT_FAMILY_REGULAR,
   FONT_FAMILY_MEDIUM,
   loginErrorMessage,
   GET_USER_PROFILE,
   isNewAPI,
   gray,
   rememberAccount,
   isWindows,
   isDesktop,
   primaryColor700,
   hoverBtnBgColor,
   primaryColor800,
   BACK_BUTTON_HOVER_COLOR,
   FONT_FAMILY_BOLD,
   primaryState500,
   isHoverEnabled,
   isWeb,
   togglePassword,
   isMacOS,
   forgotPassword,
   forgotPasswordSubTitle,
   cancel,
   WHITE_BUTTON_HOVER_COLOR,
   SEND_TEMPRORARY_PASSWORD,
   RequestingPassword,
   SignInLoader,
   LoginError,
} from '../../utils/utils';
import RNFS from '../../components/fs';
import {useDispatch, useSelector} from 'react-redux';
import {useIsFocused, useNavigation} from '@react-navigation/native';
import {selectBarcode, setBarcode} from '../../redux/slices/ScannerSlice';
import {retrieveAppData, storeAppData} from '../../utils/preference';
import {
   selectScreenOrientation,
   setIsBottomLogoToShown,
} from '../../redux/slices/ScreenOrientationSlice';
import {apiPostRequest} from '../../service/network_access';
import ErrorView from './error';
import ThreeDotsLoader from '../../utils/norcat_loading';
import {setSignIn} from '../../redux/slices/AuthSlice';
import logger from '../../utils/logger';
import {ContactUsLink, NorcatOrgBtn} from '../../components/common';
import {isMobile, isSafari, isTablet} from 'react-device-detect';
import PasswordHint from '../../components/password';
import ThreeDotsLoaderWindows from '../../utils/norcat_loading_windows';

export const LoginView = props => {
   const isIOS = Platform.OS === 'ios';
   const isAndroid = Platform.OS === 'android';
   const isMobilePlatform = isIOS || isAndroid;
   const [isEmailFocused, setIsEmailFocused] = useState(false);
   const [isError, setIsError] = useState(false);
   const [isApiLoading, setApiLoading] = useState(false);
   const [errorMessage, setErrorMessage] = useState('');
   const [isPasswordFocused, setIsPasswordFocused] = useState(false);
   const [email, setEmail] = useState('');
   const [clearEmail, setClearEmail] = useState(true);
   const [password, setPassword] = useState('');
   const [checked, setChecked] = useState(false);
   const dispatch = useDispatch();
   const navigation = useNavigation();
   const barCodeScanned = useSelector(selectBarcode);
   const isLandscapeMode = useSelector(selectScreenOrientation);
   const [isHover, setHover] = useState(false);
   const [txt1Hover, setTxt1Hover] = useState(false);
   const [txt2Hover, setTxt2Hover] = useState(false);
   const [checkHover, setChkHover] = useState(false);
   let isMounted = true;
   const isScreenFocused = useIsFocused();

   // forgot password flow
   const [isForgotPasswordOn, setForgotPasswordOn] = useState(false);
   const [firstName, setFirstName] = useState(null);
   const [secondName, setSecondName] = useState(null);
   const [isFirstNameFocused, setFirstNameFocused] = useState(false);
   const [isSecondNameFocused, setSecondNameFocused] = useState(false);
   const [isEmailSent, setEmailSent] = useState(false);

   if (barCodeScanned !== '') {
      navigation.goBack();
      const barcodeData = {barcode: ''};
      dispatch(setBarcode(barcodeData));
      isNewAPI
         ? handleSignINv6(barCodeScanned, 'QRLOGIN')
         : handleSignIN(barCodeScanned, 'QRLOGIN');
   }
   //State variable to track password visibility
   const [showPassword, setShowPassword] = useState(false);
   // Function to toggle the password visibility state
   const toggleShowPassword = () => {
      setShowPassword(!showPassword);
      //inputFocus();
   };
   const emailHandleFocus = () => {
      setIsEmailFocused(true);
      setIsPasswordFocused(false);
   };
   const emailHandleBlur = () => {
      setIsEmailFocused(false);
   };
   const passwordHandleFocus = () => {
      setIsEmailFocused(false);
      setIsPasswordFocused(true);
   };
   const passwordHandleBlur = () => {
      setIsPasswordFocused(false);
   };
   // forgot password action
   const firstNameHandleFocus = () => {
      setFirstNameFocused(true);
   };
   const firstNameHandleBlur = () => {
      setFirstNameFocused(false);
   };
   const secondNameHandleFocus = () => {
      setSecondNameFocused(true);
   };
   const secondNameHandleBlur = () => {
      setSecondNameFocused(false);
   };
   const borderFirstNameStyle = {
      borderWidth: 1,
      borderColor: isFirstNameFocused ? primaryColor500 : primaryState300,
   };
   const borderSecondNameStyle = {
      borderWidth: 1,
      borderColor: isSecondNameFocused ? primaryColor500 : primaryState300,
   };

   const borderEmailStyle = {
      borderWidth: 1,
      borderColor: isEmailFocused ? primaryColor500 : primaryState300,
   };

   const borderPasswordStyle = {
      borderWidth: 1,
      borderColor: isPasswordFocused ? primaryColor500 : primaryState300,
   };

   const inputWebRef = React.useRef();
   const inputEmailRef = React.useRef();
   const inputPassRef = React.useRef();

   useEffect(() => {
      if (isWeb) {
         const INTV = setInterval(() => {
            if (
               inputWebRef.current &&
               !isEmailFocused &&
               !isPasswordFocused &&
               isHoverEnabled &&
               !isFirstNameFocused &&
               !isSecondNameFocused
            ) {
               inputWebRef?.current?.focus();
            }
         }, 1000);
         return () => clearInterval(INTV);
      }
   }, [
      isEmailFocused,
      isPasswordFocused,
      isFirstNameFocused,
      isSecondNameFocused,
   ]);

   useEffect(() => {
      if ((isWindows && isScreenFocused) || !isWindows) {
         if (isMounted) {
            try {
               retrieveAppData(REMEMBER_ACCOUNT)
                  .then(data => {
                     logger(`RETRIVEDATA:: ${data === 'true'} }`);
                     setChecked(data === 'true');
                  })
                  .catch(err => logger({err}));

               retrieveAppData(ACCOUNT_EMAIL)
                  .then(data => {
                     logger(`EMAIL DATA :: ${data} }`);
                     setEmail(data);
                     if (data !== '') setClearEmail(false);
                  })
                  .catch(err => logger({err}));

               retrieveAppData(ACCOUNT_PASSWORD)
                  .then(data => {
                     logger(`PASSWORD DATA:: ${data} }`);
                     setPassword(data);
                  })
                  .catch(err => logger({err}));
            } catch (error) {
               logger(error);
            }
         }
         if (isWindows) {
            return () => {
               isMounted = false;
            };
         }
      }
   }, [isScreenFocused]);

   function handleBarcode() {
      navigation.navigate('BarcodeScannerScreen');
   }

   function onSignIn() {
      const isValidatForGotPass = isValidFormForForgotPassword({
         email: email,
         firstName: firstName,
         secondName: secondName,
      });
      if (isForgotPasswordOn && isValidatForGotPass) {
         setLoadingView(true);
         handleforgotPassword(email, firstName, secondName);
         return;
      } else if (!isForgotPasswordOn) {
         if (checked) {
            storeAppData(ACCOUNT_EMAIL, email);
            storeAppData(ACCOUNT_PASSWORD, password);
         } else {
            storeAppData(ACCOUNT_EMAIL, '');
            storeAppData(ACCOUNT_PASSWORD, '');
         }
         const emailPattern =
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
         if (email === '' || password === '') {
            setErrorView(true);
            setErrorMessage('Please enter valid credentials.');
         } else {
            isNewAPI
               ? handleSignINv6(email, password)
               : handleSignIN(email, password);
         }
      }
   }

   function setErrorView(value) {
      setIsError(value);
      dispatch(
         setIsBottomLogoToShown({
            isBottomLogoToShown: isForgotPasswordOn ? false : !value,
         }),
      );
   }

   function setLoadingView(value) {
      setApiLoading(value);
      dispatch(
         setIsBottomLogoToShown({
            isBottomLogoToShown: isForgotPasswordOn ? false : !value,
         }),
      );
   }

   function isValidFormForForgotPassword({email, firstName, secondName}) {
      if (isForgotPasswordOn) {
         const emailPattern =
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
         if (email === '' || !emailPattern.test(email)) {
            setErrorView(true);
            setErrorMessage('Please enter valid credentials.');
            return false;
         } else if (firstName == null) {
            setErrorView(true);
            setErrorMessage('Please enter valid first name.');
            return false;
         } else if (secondName == null) {
            setErrorView(true);
            setErrorMessage('Please enter valid last name.');
            return false;
         } else {
            return true;
         }
      }
   }

   function handleSignIN(email, password) {
      const reqParms = {emailAddress: email, p: password};
      setLoadingView(true);
      logger({emailAddress: email, p: password});
      try {
         apiPostRequest({url: GET_LOGIN, parms: reqParms})
            .then(res => {
               setLoadingView(false);
               if (res && res.Authenticated) {
                  const user = {
                     isLoggedIn: true,
                     userName: res.ACMEmployeeFirstName,
                     authData: res,
                  };
                  storeAppData(AUTHDATA, JSON.stringify(res));
                  dispatch(setSignIn(user));
               } else if (typeof res === 'string') {
                  setErrorView(true);
                  setErrorMessage(res);
               } else {
                  setErrorView(true);
                  setErrorMessage('Please verify your login credentials.');
               }
            })
            .catch(err => logger({err}));
      } catch (error) {}
   }

   async function handleforgotPassword(email, firstName, lastNme) {
      const reqParms = {
         theData: JSON.stringify({
            Email: email,
            FirstName: firstName,
            LastName: lastNme,
         }),
      };
      setLoadingView(true);
      try {
         const res = await apiPostRequest({
            url: SEND_TEMPRORARY_PASSWORD,
            parms: reqParms,
         });

         try {
            setLoadingView(false);
            if (res && res.StatusResult) {
               setErrorView(true);
               setEmailSent(true);
               setFirstName('');
               setSecondName('');
               setErrorMessage(res.StatusMessage);
            } else if (typeof res === 'string') {
               logger('Exception Response:: ' + res);
               setErrorView(true);
               setErrorMessage(res);
            } else {
               logger('Error Response:: ' + res);
               setErrorView(true);
               setErrorMessage('Please verify your credentials.');
            }
         } catch (error) {
            logger('Error in login::', error);
         }
      } catch (error) {
         logger('Error in login::', error);
      }
   }
   async function handleSignINv6(email, password) {
      const reqParms = {
         theData: JSON.stringify({
            Username: email,
            Password: password,
         }),
      };
      setLoadingView(true);
      try {
         const res = await apiPostRequest({
            url: GET_USER_PROFILE,
            parms: reqParms,
         });
         try {
            setLoadingView(false);
            if (res && res.Authenticated) {
               logger('Success Response:: ' + JSON.stringify(res));
               const user = {
                  isLoggedIn: true,
                  userName: res.FirstName,
                  authData: res,
               };
               storeAppData('TOKEN', res.GuidID);
               storeAppData(AUTHDATA, JSON.stringify(res));
               dispatch(setSignIn(user));
            } else if (typeof res === 'string') {
               logger('Exception Response:: ' + res);
               setErrorView(true);
               setErrorMessage(res);
            } else {
               logger('Error Response:: ' + res);
               setErrorView(true);
               setErrorMessage('Please verify your login credentials.');
            }
         } catch (error) {
            logger('Error in login::', error);
         }
      } catch (error) {
         logger('Error in login::', error);
      }
   }

   function handleRetryClick() {
      if (isForgotPasswordOn && isEmailSent) {
         setForgotPasswordOn(false);
         dispatch(
            setIsBottomLogoToShown({
               isBottomLogoToShown: isForgotPasswordOn ? false : true,
            }),
         );
         setEmailSent(false);
      }

      setErrorView(false);
   }

   function handleCheckClick() {
      const rem = !checked ? 'true' : 'false';
      storeAppData(REMEMBER_ACCOUNT, rem);
      setChecked(!checked);
      //inputFocus();
   }
   const handleKeyDown = event => {
      if (event.nativeEvent.key === 'Enter') {
         onSignIn();
      }
   };
   function inputFocus() {
      //Email
      if (isWeb && inputEmailRef) {
         inputEmailRef?.current?.focus();
      }
      //Password
      if (isWeb && inputPassRef) {
         if (isPasswordFocused) {
         }
         inputPassRef?.current?.focus();
      }
      //Checkbox
   }
   return (
      <View>
         <View
            style={{
               justifyContent: 'flex-start',
               alignItems: 'center',
               borderColor:
                  Platform.OS === 'windows' ? 'rgba(158, 150, 150, 0.2)' : null,
               borderWidth: Platform.OS === 'windows' ? 2 : null,
               borderRadius: Platform.OS === 'windows' ? 10 : null,
            }}>
            <View
               style={[
                  styles.card,
                  {
                     minHeight: !isLandscapeMode
                        ? 224
                        : isForgotPasswordOn && !isWeb && !isError
                        ? isIOS
                           ? 425
                           : isDesktop
                           ? 300
                           : 460
                        : 286,
                     marginTop: !isLandscapeMode ? 5 : null,
                  },
               ]}>
               {isError ? (
                  <ErrorView
                     title={isForgotPasswordOn ? 'Alert!' : LoginError}
                     message={errorMessage}
                     buttonText={isEmailSent ? 'OK' : 'Retry'}
                     onRetry={handleRetryClick}
                     isEmail={isEmailSent}
                     headerIcon={
                        isForgotPasswordOn
                           ? isEmailSent
                              ? require('../../assets/email_send.png')
                              : require('../../assets/error_reset.png')
                           : null
                     }
                  />
               ) : isApiLoading ? (
                  isWindows ? (
                     <ThreeDotsLoaderWindows
                        title={
                           isForgotPasswordOn
                              ? RequestingPassword
                              : SignInLoader
                        }
                     />
                  ) : isMacOS ? (
                     <ThreeDotsLoader
                        title={
                           isForgotPasswordOn
                              ? RequestingPassword
                              : SignInLoader
                        }
                     />
                  ) : (
                     <View
                        style={{
                           padding: isLandscapeMode ? 32 : 24,
                           flex: 1,
                        }}>
                        <ThreeDotsLoader
                           title={
                              isForgotPasswordOn
                                 ? RequestingPassword
                                 : SignInLoader
                           }
                        />
                     </View>
                  )
               ) : (
                  <View
                     style={[
                        styles.cardContent,
                        {
                           paddingVertical:
                              props.isPortrait && isAndroid ? 16 : 24,
                        },
                     ]}>
                     {isWeb && (
                        <TextInput
                           ref={inputWebRef}
                           style={{
                              height: 0,
                              width: 0,
                           }}
                           autoFocus={isHoverEnabled} //For enter key event in web platform
                           onKeyPress={event => {
                              if (event.nativeEvent.key === 'Enter') {
                                 onSignIn();
                              }
                           }}
                        />
                     )}
                     <Text
                        style={[
                           styles.sectionTitle,
                           {
                              marginBottom:
                                 props.isPortrait && isAndroid ? 10 : 16,
                           },
                        ]}>
                        {isForgotPasswordOn ? forgotPassword : AccountSignIn}
                     </Text>
                     {isForgotPasswordOn && (
                        <Text style={[styles.subtitle]}>
                           {forgotPasswordSubTitle}
                        </Text>
                     )}
                     <View style={styles.line} />
                     <TextInput
                        style={[styles.inputStyle, borderEmailStyle]}
                        keyboardType="email-address"
                        placeholder={isForgotPasswordOn ? 'Email' : 'Username'}
                        placeholderTextColor={gray}
                        value={email}
                        color="#000000"
                        //underlineColorAndroid={'rgba(0,0,0,0)'}
                        onChangeText={email => setEmail(email)}
                        onFocus={emailHandleFocus}
                        onBlur={emailHandleBlur}
                        onKeyPress={handleKeyDown}
                        autoFocus={isHoverEnabled}
                        ref={inputEmailRef}
                     />
                     {/*first name*/}
                     {isForgotPasswordOn && (
                        <TextInput
                           style={[styles.inputStyle, borderFirstNameStyle]}
                           keyboardType="default"
                           placeholder="First name"
                           placeholderTextColor={gray}
                           value={firstName}
                           color="#000000"
                           //underlineColorAndroid={'rgba(0,0,0,0)'}
                           onChangeText={firstName => setFirstName(firstName)}
                           onFocus={firstNameHandleFocus}
                           onBlur={firstNameHandleBlur}
                           onKeyPress={handleKeyDown}
                           autoFocus={email === '' ? false : isHoverEnabled}
                        />
                     )}
                     {isForgotPasswordOn && (
                        <TextInput
                           style={[styles.inputStyle, borderSecondNameStyle]}
                           keyboardType="default"
                           placeholder="Last name"
                           placeholderTextColor={gray}
                           value={secondName}
                           color="#000000"
                           //underlineColorAndroid={'rgba(0,0,0,0)'}
                           onChangeText={sName => setSecondName(sName)}
                           onFocus={secondNameHandleFocus}
                           onBlur={secondNameHandleBlur}
                           onKeyPress={handleKeyDown}
                           autoFocus={false}
                        />
                     )}
                     {/* Password */}
                     {!isForgotPasswordOn && (
                        <View
                           style={{
                              justifyContent: 'center',
                              alignSelf: 'stretch',
                           }}>
                           <TextInput
                              style={[
                                 styles.inputStyle,
                                 borderPasswordStyle,
                                 {
                                    paddingRight:
                                       isSafari && isLandscapeMode ? 35 : 30,
                                 },
                              ]}
                              underlineColorAndroid={'rgba(0,0,0,0)'}
                              placeholder="Password"
                              placeholderTextColor={gray}
                              value={password}
                              color="#000000"
                              onChangeText={password => setPassword(password)}
                              secureTextEntry={!showPassword}
                              onFocus={passwordHandleFocus}
                              onBlur={passwordHandleBlur}
                              onKeyPress={handleKeyDown}
                              ref={inputPassRef}
                              key={showPassword ? 'secure' : 'nonsecure'}
                              /** To resolve mac issue above key is used */
                           />
                           {togglePassword && (
                              <PasswordHint
                                 onPress={toggleShowPassword}
                                 isLandscapeMode={isLandscapeMode}
                                 showPassword={showPassword}
                              />
                           )}
                        </View>
                     )}
                     {/*  */}
                     {!isForgotPasswordOn && (
                        <View
                           style={{
                              flexDirection: 'row',
                              alignContent: 'flex-start',
                              justifyContent: 'space-between',
                              flexWrap: 'wrap',
                           }}>
                           <View
                              onMouseEnter={() => {
                                 setChkHover(true);
                              }}
                              onMouseLeave={() => {
                                 setChkHover(false);
                              }}
                              style={{
                                 flexDirection: 'row',
                                 alignContent: 'flex-start',
                                 alignItems: 'center',
                              }}>
                              <TouchableOpacity
                                 onPress={handleCheckClick}
                                 style={{
                                    width: 28,
                                    height:
                                       props.isPortrait && isAndroid ? 16 : 36,
                                    paddingVertical: 8,
                                    paddingRight: 8,
                                    paddingLeft: 0,
                                    justifyContent: 'center',
                                 }}>
                                 <Image
                                    source={
                                       checked
                                          ? require('../../assets/checked.png')
                                          : require('../../assets/unchecked.png')
                                    }
                                    style={[
                                       {
                                          width: 20,
                                          height: 20,
                                       },
                                       isHoverEnabled && {
                                          opacity: checkHover ? 0.7 : 1,
                                       },
                                    ]}
                                 />
                              </TouchableOpacity>
                              <Text
                                 style={{
                                    textAlignVertical: 'center',
                                    color: checkHover
                                       ? hoverBtnBgColor
                                       : primaryState800,
                                    fontSize: 12,
                                    marginRight: 8,
                                    fontFamily: checkHover
                                       ? FONT_FAMILY_BOLD
                                       : FONT_FAMILY_SEMI_BOLD,
                                    fontWeight: '600',
                                 }}>
                                 {rememberAccount}
                              </Text>
                           </View>
                           <TouchableOpacity
                              onMouseEnter={() => {
                                 setTxt1Hover(true);
                              }}
                              onMouseLeave={() => {
                                 setTxt1Hover(false);
                              }}
                              style={{justifyContent: 'center'}}
                              onPress={() => {
                                 setForgotPasswordOn(true);
                                 dispatch(
                                    setIsBottomLogoToShown({
                                       isBottomLogoToShown: false,
                                    }),
                                 );
                              }}>
                              <Text
                                 style={[
                                    {
                                       textAlignVertical: 'center',
                                       color: primaryColor500,
                                       fontSize: 12,
                                       fontWeight: isLandscapeMode
                                          ? '700'
                                          : '600',
                                       fontFamily: FONT_FAMILY_SEMI_BOLD,
                                       textDecorationLine:
                                          txt1Hover && isHoverEnabled
                                             ? 'underline'
                                             : 'none',
                                    },
                                 ]}>
                                 Forgot Password?
                              </Text>
                           </TouchableOpacity>
                        </View>
                     )}
                     <ActionButton
                        isMobile={isMobilePlatform}
                        onSignIn={onSignIn}
                        onBarcodeClick={handleBarcode}
                        isForgotPasswordOn={isForgotPasswordOn}
                        oncancelForgotPassword={() => {
                           setForgotPasswordOn(false);
                           dispatch(
                              setIsBottomLogoToShown({
                                 isBottomLogoToShown: isForgotPasswordOn
                                    ? false
                                    : true,
                              }),
                           );
                           setFirstName('');
                           setSecondName('');
                           if (clearEmail) setEmail('');
                        }}
                     />
                  </View>
               )}
            </View>
         </View>
         <View
            style={{
               flexDirection: 'row',
               alignItems: 'center',
               justifyContent: 'center',
               marginTop: props.isPortrait && isAndroid ? 20 : 18,
            }}>
            <Text
               style={{
                  textAlign: 'center',
                  fontWeight: '400',
                  fontSize: 14,
                  color: base100,
                  fontFamily: FONT_FAMILY_REGULAR,
               }}>
               {DoNotHaveAnAccount}
            </Text>
            <ContactUsLink />
         </View>
         <View style={{alignItems: 'center'}}>
            <NorcatOrgBtn />
         </View>
      </View>
   );
};

const ActionButton = props => {
   const [isHover, setHover] = useState(false);
   const [cancelHover, setCancelHover] = useState(false);

   if (props.isForgotPasswordOn) {
      return (
         <View
            style={{
               flexDirection: props.isMobile ? 'column' : 'row-reverse',
            }}>
            <TouchableOpacity
               onMouseEnter={() => {
                  setHover(true);
               }}
               onMouseLeave={() => {
                  setHover(false);
               }}
               style={[
                  styles.signUpButton,
                  {
                     backgroundColor: isHover
                        ? hoverBtnBgColor
                        : primaryColor500,
                     flex: 1,
                     marginBottom: props.isMobile ? 8 : null,
                     marginLeft: props.isMobile ? null : 8,
                  },
               ]}
               onPress={() => {
                  props.onSignIn();
               }}>
               <Text style={styles.buttonText}>
                  {props.isForgotPasswordOn ? 'Send' : SignIn}
               </Text>
            </TouchableOpacity>
            <TouchableOpacity
               style={{
                  backgroundColor: cancelHover
                     ? WHITE_BUTTON_HOVER_COLOR
                     : white,
                  minHeight: 48,
                  borderRadius: 6,
                  justifyContent: 'center',
                  borderWidth: 1,
                  flex: 1,
                  borderColor: primaryColor400,
                  ...Platform.select({
                     windows: {
                        borderWidth: 1.01,
                     },
                  }),
               }}
               onMouseEnter={() => {
                  setCancelHover(true);
               }}
               onMouseLeave={() => {
                  setCancelHover(false);
               }}
               onPress={() => {
                  props.oncancelForgotPassword();
                  setCancelHover(false);
               }}>
               <Text
                  style={{
                     color: primaryColor500,
                     fontSize: 16,
                     fontWeight: '500',
                     textAlign: 'center',
                     fontFamily: FONT_FAMILY_MEDIUM,
                  }}>
                  {cancel}
               </Text>
            </TouchableOpacity>
         </View>
      );
   } else if (!props.isMobile) {
      return (
         <View style={{marginTop: 24}}>
            <TouchableOpacity
               onMouseEnter={() => {
                  setHover(true);
               }}
               onMouseLeave={() => {
                  setHover(false);
               }}
               style={[
                  styles.signUpButton,
                  {
                     backgroundColor: isHover
                        ? hoverBtnBgColor
                        : primaryColor500,
                  },
               ]}
               onPress={() => {
                  props.onSignIn();
               }}>
               <Text style={styles.buttonText}>{SignIn}</Text>
            </TouchableOpacity>
         </View>
      );
   } else {
      return (
         <View style={{marginTop: 24}}>
            <TouchableOpacity
               onMouseEnter={() => {
                  setHover(true);
               }}
               onMouseLeave={() => {
                  setHover(false);
               }}
               style={[
                  styles.signUpButton,
                  {
                     backgroundColor: isHover
                        ? hoverBtnBgColor
                        : primaryColor500,
                  },
               ]}
               onPress={() => {
                  props.onSignIn();
               }}>
               <Text style={styles.buttonText}>{SignIn}</Text>
            </TouchableOpacity>

            <TouchableOpacity
               style={styles.qrButton}
               onPress={() => {
                  props.onBarcodeClick();
               }}>
               <View
                  style={{
                     flexDirection: 'row',
                     justifyContent: 'center',
                     alignItems: 'center',
                  }}>
                  <Image
                     source={require('../../assets/default_qrcode.png')}
                     style={{width: 14, height: 14}}
                  />
                  <Text
                     style={[
                        styles.buttonText,
                        {color: primaryColor500, marginLeft: 8},
                     ]}>
                     {QrSignIn}
                  </Text>
               </View>
            </TouchableOpacity>
         </View>
      );
   }
};
const styles = StyleSheet.create({
   container: {
      backgroundColor: appBackgroundWhiteBG,
      flex: 1,
      height: '100vh',
   },
   cardContainer: {
      marginTop: 24,
      marginEnd: 24,
      marginStart: 24,
      flex: 1,
   },
   subtitle: {
      fontSize: 12,
      textAlign: 'center',
      marginBottom: 8,
      fontWeight: '500',
      color: primaryState500,
      fontFamily: FONT_FAMILY_MEDIUM,
   },
   card: {
      borderRadius: 5,
      elevation: 3,
      backgroundColor: '#fff',
      shadowOffset: {width: 0, height: 1},
      shadowColor: '#333',
      shadowOpacity: 0.3,
      shadowRadius: Platform.OS === 'web' ? 7 : 2,
      width: '99%',
   },
   cardContent: {
      marginVertical: 5,
      alignContent: 'center',
      justifyContent: 'flex-start',
      paddingHorizontal: 24,
   },
   sectionTitle: {
      fontSize: 20,
      fontWeight: '600',
      textAlign: 'center',
      color: primaryState800,
      fontFamily: FONT_FAMILY_SEMI_BOLD,
   },
   line: {
      height: 2,
      opacity: 0.1,
      marginHorizontal: 10,
      backgroundColor: '#000000',
      marginBottom: 24,
   },
   inputStyle: {
      width: '100%',
      backgroundColor: white,
      marginBottom: 16,
      alignItems: 'flex-end',
      borderRadius: 4,
      fontSize: isMobile ? 16 : 12, // decreasing fontSize < 15 will cause zoom issue on web-small-devices
      maxHeight: 48,
      padding: 10,
      fontWeight: '700',
      color: '#000000',
   },
   signUpButton: {
      backgroundColor: primaryColor500,
      minHeight: 48,
      borderRadius: 6,
      justifyContent: 'center',
   },
   qrButton: {
      backgroundColor: white,
      minHeight: 48,
      borderRadius: 6,
      justifyContent: 'center',
      marginTop: 10,
      borderWidth: 1,
      borderColor: buttonBorderColor,
   },
   buttonText: {
      color: 'white',
      fontSize: 16,
      fontWeight: '500',
      textAlign: 'center',
      fontFamily: FONT_FAMILY_MEDIUM,
   },
});
